import { render, staticRenderFns } from "./wageTotalSaleman.vue?vue&type=template&id=2f6e533e&scoped=true&"
import script from "./wageTotalSaleman.vue?vue&type=script&lang=js&"
export * from "./wageTotalSaleman.vue?vue&type=script&lang=js&"
import style0 from "./wageTotalSaleman.vue?vue&type=style&index=0&id=2f6e533e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f6e533e",
  null
  
)

export default component.exports